/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

const tableCols = [
	{
		field: 'LOG_DATE_TIME',
		header: 'Log Date & Time',
		visible: true,
		filter: false,
		sort: true,
		tooltip: 'Log date & time',
		width: 200
	},
	{
		field: 'DURATION',
		header: 'Duration',
		visible: true,
		filter: false,
		sort: true,
		tooltip: 'Duration (milliseconds)',
		width: 120
	},
	{
		field: 'SCOPE_NAME',
		header: 'Scope Name',
		visible: true,
		filter: false,
		sort: true,
		tooltip: 'Scope name',
		width: 120
	},
	/*{
		field: 'MESSAGE_TYPE',
		header: 'Message Type',
		visible: false,
		filter: false,
		sort: false,
		tooltip: 'Message type',
		width: 0
	},*/
	/*{
		field: 'LOG_MESSAGE',
		header: 'Log Message',
		visible: false,
		filter: false,
		sort: false,
		tooltip: 'Log message',
		width: 120
	},*/
	{
		field: 'ED1_ID',
		header: 'ED1 ID',
		visible: true,
		filter: true,
		sort: true,
		tooltip: 'ED1 ID',
		width: 100
	},
	{
		field: 'ED1_DOC_NO',
		header: 'ED1 Document Number',
		visible: true,
		filter: true,
		sort: true,
		tooltip: 'ED1 Document Number',
		width: 110
	},
	/*{
		field: 'EDI_LOG_ID',
		header: 'EDI Log ID',
		visible: false,
		filter: false,
		sort: true,
		tooltip: 'EDI Log ID',
		width: 90
	},*/
	/*{
		field : 'COMPANY_NAME',
		header : 'Company Name',
		visible : false,
		filter : false,
		sort : false,
		tooltip : 'Company Name',
		width : 160
	},*/
	{
		field: 'CUSTOMER_NAME',
		header: 'Customer Name',
		visible: true,
		filter: false,
		sort: false,
		tooltip: 'Customer name',
		width: 175
	},
	{
		field: 'ED1_TYPE',
		header: 'ED1 Type',
		visible: true,
		filter: true,
		sort: true,
		tooltip: 'ED1 Type',
		width: 110
	}/*,
	{
        field: 'CONTAINER_NAME',
        header: 'Container',
        visible: true,
        filter: false,
        sort: false,
        tooltip: 'Container name',
        width: 30
    },
    {
        field: 'CONTEXT_ID',
        header: 'Context ID',
        visible: true,
        filter: false,
        sort: false,
        tooltip: 'Context ID',
        width: 30
    },
	{
		field: 'API_NAME',
		header: 'API Name',
		visible: true,
		filter: false,
		sort: false,
		tooltip: 'API Name',
		width: 30
	},
	{
		field: 'API_URL',
		header: 'API URL',
		visible: true,
		filter: false,
		sort: false,
		tooltip: 'API URL',
		width: 30
	}*/
];
export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transaction-reports/asn-run-time-list/asn-run-time-list.cols.ts